// Do not edit directly
// Generated on Fri, 02 Jan 2026 03:29:50 GMT

export const Laptop = 1440;
export const LaptopSm = 1280;
export const Tablet = 1024;
export const Mobile = 560;
export const MobileSm = 420;
